import React from 'react'
import CloseIcon from '@uniiverse/library/assets/icons/x.svg'
import isEmpty from 'lodash/isEmpty'

import { ModalComponent as Modal } from 'src/elements/Modal/Modal'
import { Attraction } from 'src/interfaces/Attraction'

import { AttractionWidget } from '../AttractionWidget/AttractionWidget'

import { SocialBar } from './SocialBar'

const style = require('./AttractionModal.css')

interface AttractionModalProps {
  selectedAttraction: Attraction,
  onClose: () => void,
}

export const AttractionModal = ({ selectedAttraction, onClose }: AttractionModalProps) => {
  const {
    name,
    data,
    imageURL,
    bio,
    embeddedWidgetCode,
  } = selectedAttraction
  const heroImageBackground =
    `url(${imageURL}) lightgray 50% / cover no-repeat`
  const hasSocials = data && !isEmpty(data)

  return (
    <Modal
      showModal={!!selectedAttraction}
      onClose={onClose}
      customClass={style.attractionModalBase}
      bodyOpenClassName={style.lockScroll}
      customOverlayClass={style.customOverlay}
    >
      <div
        className={style.attractionModalHero}
        style={{
          background: heroImageBackground,
        }}
      >
        <div className={style.attractionModalButtonContainer}>
          <button className={style.attractionModalCloseButton} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
      </div>
      <div className={style.attractionModalContent}>
        {
          embeddedWidgetCode &&
            <div className={style.attractionModalWidgetContainer}>
              <AttractionWidget widgetCode={embeddedWidgetCode} />
            </div>
        }
        <h3 className={style.attractionModalHeading}>
          {name}
        </h3>
        {
          bio &&
            <p className={style.attractionModalBio}>
              {bio}
            </p>
        }
        {
          hasSocials && (
            <div className={style.socialMedia}>
              <SocialBar socials={data} />
            </div>
          )
        }
      </div>
    </Modal>
  )
}
